import type { ReactNode } from "react";

// CopilotKit removed. This wrapper is kept so imports don't break.
// Replace with any AI runtime integration when ready.
export function CopilotProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
